import { generateHTML } from '@tiptap/html';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import Strike from '@tiptap/extension-strike';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';

export const extensions = [
  StarterKit.configure({
    heading: {
      levels: [1, 2, 3],
    },
  }),
  Underline,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Subscript,
  Superscript,
  Strike,
  Link.configure({
    openOnClick: false,
    autolink: true,
    defaultProtocol: 'https',
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      class: 'text-blue-500 hover:underline',
    },
  }),
  Image.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        width: { default: '100%' },
        height: { default: null },
        style: { default: null }
      }
    }
  }).configure({
    inline: true,
    allowBase64: true,
    HTMLAttributes: {
      class: 'rounded-lg border cursor-move',
      draggable: 'true'
    },
  }),
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      class: 'border-collapse'
    },
  }),
  TableRow,
  TableHeader,
  TableCell,
];

export const jsonToHtml = (jsonContent) => {
  if (!jsonContent) return '';
  
  try {
    // If content is already HTML, return as-is
    if (typeof jsonContent === 'string' && jsonContent.startsWith('<')) {
      return jsonContent;
    }
    
    // If content is JSON string, parse first
    const content = typeof jsonContent === 'string' 
      ? JSON.parse(jsonContent) 
      : jsonContent;
    
    return generateHTML(content, extensions);
  } catch (error) {
    console.error('Error converting JSON to HTML:', error);
    return '';
  }
};